import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
    carousel: {
        // position: "fixed",
        padding: "",
        margin: '0'
    }

}));
